module.exports = __webpack_public_path__ + "assets/img/a.search_icon.83695ebc.svg";